import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const supportedLngs = ['en-US'];

const formatDecimal = (value?: string | number): string => {
  if (typeof value === 'string' || typeof value === 'undefined') {
    value = Number(value);
    if (isNaN(value)) return '--';
  }

  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value);
};

i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng.split('-')[0]);
});

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs,
    fallbackLng: 'en-US',
    defaultNS: 'translation',
    ns: ['datetime', 'legal'], // pre-loaded for use outside React hooks; other namespaces are bundled via addResourceBundle
    interpolation: {
      escapeValue: false,
    },
    joinArrays: '',
     parseMissingKeyHandler: (key, defaultValue) => defaultValue ?? `**${key}**`,
    detection: {
      order: ['querystring', 'path', 'navigator'],
      lookupFromPathIndex: 0,
      lookupQuerystring: 'locale',
    },
  });

// interpolation.format removed in i18next v23 — register named formatters via the formatter service
i18n.services.formatter?.add('currency', (value: string | number) => formatDecimal(value));

export default i18n;
